import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.background.paper,
    color: palette.text.secondary,
    '& $avatar': {
      color: palette.common.white,
    },
  },
};
